export default __webpack_public_path__ + "static/homepagePartners-aab4b7657c84ec84d5b7bd035df1c7be.png";